import { Check, CircleDashed, ListTodo } from 'lucide-react';
import { LINEUP_STATUS_LABELS, type LineupStatus } from '@bm/contracts';

/** Nie nur Farbe — immer Icon + Text (§12 der Anforderung), damit der Status
 * auch für Farbfehlsichtige und im Screenreader eindeutig ist. Wiederverwendet
 * auf der Saisonspiel-Karte UND oben im LineupModal selbst. */
export function LineupStatusBadge({ status, className = '' }: { status: LineupStatus; className?: string }) {
  const cfg = {
    empty: { icon: CircleDashed, cls: 'bg-slate-100 text-slate-500' },
    incomplete: { icon: ListTodo, cls: 'bg-amber-50 text-amber-700' },
    complete: { icon: Check, cls: 'bg-green-50 text-green-700' },
  }[status];
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${cfg.cls} ${className}`}>
      <Icon size={12} />
      Aufstellung {LINEUP_STATUS_LABELS[status]}
    </span>
  );
}
